var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    { staticClass: "c-illustration", attrs: { id: "selectorIllustration" } },
    [
      _vm.image
        ? _c("responsive-image", {
            attrs: {
              id: _vm.image.id,
              css: "c-illustration__bgimg",
              alt: _vm.illustration.name,
            },
            on: { "image-size": _vm.updateImageSize },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedSection != "all"
        ? _c(
            "svg",
            {
              staticClass: "c-illustration__svg c-illustration__residence",
              attrs: {
                viewBox: _vm.viewBox,
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            _vm._l(_vm.shapes, function (shape) {
              return _c("ShapeComponent", {
                key: shape.id,
                attrs: { shape: shape },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedSection === "all"
        ? _c(
            "svg",
            {
              staticClass: "c-illustration__svg c-illustration__section",
              attrs: {
                viewBox: _vm.viewBox,
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            _vm._l(_vm.shapes, function (shape) {
              return _c("ShapeComponent", {
                key: shape.id,
                attrs: { shape: shape },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.illustration.hasCompass === true
        ? _c("compass-arrow", {
            attrs: { rotation: _vm.illustration.compassAngle },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }